import * as Yup from "yup";

const ProposicaoAcontecimentosCreateSchema = Yup.object({
    descricao: Yup.string().required({ name: "descricao", err: "Campo com preenchimento obrigatório" }),
});


export default ProposicaoAcontecimentosCreateSchema;